(function () {
  var activeTrigger = null;

  function getPanel() {
    return document.querySelector('[data-kbd-configurator-panel]');
  }

  function openPanel(trigger) {
    var panel = getPanel();
    if (!panel) return;
    activeTrigger = trigger || document.activeElement;
    document.body.classList.add('kbd-configurator-panel-open');
    panel.setAttribute('aria-hidden', 'false');
    var closeButton = panel.querySelector('[data-kbd-configurator-close]');
    if (closeButton) window.setTimeout(function () { closeButton.focus(); }, 80);
  }

  function closePanel() {
    var panel = getPanel();
    if (!panel) return;
    document.body.classList.remove('kbd-configurator-panel-open');
    panel.setAttribute('aria-hidden', 'true');
    if (activeTrigger && typeof activeTrigger.focus === 'function') activeTrigger.focus();
    activeTrigger = null;
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-kbd-configurator-open]');
    if (openButton) {
      event.preventDefault();
      openPanel(openButton);
      return;
    }

    if (event.target.closest('[data-kbd-configurator-close]')) {
      closePanel();
      return;
    }

    var panel = getPanel();
    if (panel && event.target === panel) closePanel();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && document.body.classList.contains('kbd-configurator-panel-open')) {
      closePanel();
    }
  });
})();
